'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import React from 'react';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../ui/paragraph';
import { Heading } from '../ui/heading';
import { Button } from '../ui/button';
import { GoArrowRight } from 'react-icons/go';

export type BlogCardProps = {
  blog: Blog;
  semanticTag?: 'h2' | 'h3';
};

export function BlogCard({ blog, semanticTag = 'h3' }: BlogCardProps) {
  const locale = useLocaleStore(state => state.currentLocale);

  let formattedDate;

  try {
    formattedDate = new Date(blog.created_at).toLocaleDateString(locale);
  } catch (error) {
    if (error instanceof RangeError) {
      formattedDate = new Date(blog.created_at).toLocaleDateString('en-US');
    } else {
      throw error;
    }
  }

  return (
    <Link
      href={ROUTES.BLOG_DETAIL({ slug: blog.slug })}
      className="col-span-1 grid w-full grid-cols-1 overflow-hidden rounded-[8px] transition-all hover:opacity-80 md:grid-cols-2"
    >
      <Image
        src={blog?.image?.url}
        alt={resolveImageAlt(blog?.image, blog?.name)}
        width={0}
        height={0}
        className="col-span-1 h-[193px] w-full object-cover object-center sm:h-[220px] md:h-full"
        sizes="100vw"
      />
      <div className="col-span-1 flex w-full flex-col items-start justify-start gap-6 bg-white p-4 sm:gap-8 sm:p-6 lg:gap-10 lg:p-8">
        <div className="flex w-full flex-col items-start justify-start gap-1 sm:gap-2">
          <Paragraph color="muted-foreground" innerHtml={formattedDate} className="line-clamp-2 " />
          <Heading
            title={blog.name}
            tag="h5"
            semanticTag={semanticTag}
            className="line-clamp-2 h-[39px] w-full sm:h-11 md:h-12 lg:h-[58px]"
          />
        </div>
        <Button
          asChild
          variant={'none'}
          size={'none'}
          className={cn('ea-blog-card__button', 'font-bold')}
        >
          <span data-ea-visual-tag="button" style={{ textAlign: 'center' }}>
            CELÝ ČLÁNOK <GoArrowRight size={20} />
          </span>
        </Button>
      </div>
    </Link>
  );
}
